import React from 'react';
import styled from 'styled-components';

const NonCopyableSpan = styled.span`
  user-select: none;
`;

type IProps = {
  value?: string;
};

/**
 * Copyable text without thousands separators
 * (separators are visible but not included in copyable text)
 * https://stackoverflow.com/questions/63468966/highlight-and-copy-a-numbers-without-the-separators
 */
const TextNumber = ({ value }: IProps) => {
  if (value === null || value === undefined) {
    return null;
  }
  if (!value.includes(',')) {
    return <>{value}</>;
  }
  const sections = value.split(',');
  const sectionsMaxIndex = sections.length - 1;
  return (
    <>
      {sections.map((text, index) => {
        return (
          <React.Fragment key={`${text}_${index}`}>
            {text}
            {index < sectionsMaxIndex && <NonCopyableSpan>,</NonCopyableSpan>}
          </React.Fragment>
        );
      })}
    </>
  );
};

export default TextNumber;
